import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// Define a type for the slice state
export interface UserState {
    authenticated: boolean;
    isAdmin: boolean;
    username?: string;
}

const initialState: UserState = {
    authenticated: false,
    isAdmin: false,
    username: undefined
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setAuthenticated: (state, action : PayloadAction<boolean>) => {
            state.authenticated = action.payload
            return state;
        },
        setAdmin: (state, action: PayloadAction<boolean>) => {
            state.isAdmin = action.payload
            return state
        },
        setUser: (state, action: PayloadAction<UserState>) => {
            return action.payload
        },
    },
    extraReducers: (builder) => { }
})

export const {
    setAdmin,
    setAuthenticated,
    setUser
} = userSlice.actions

export default userSlice.reducer

